/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SbSharedRefineMenuSearchResults_facetSearch$ref = any;
export type SbSharedRefineMenuTypeahead_viewer$ref = any;
export type SbSharedRefineMenuTypeahead_viewer = {
    readonly facetSearch?: {
        readonly " $fragmentRefs": SbSharedRefineMenuSearchResults_facetSearch$ref;
    } | null;
    readonly " $refType": SbSharedRefineMenuTypeahead_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SbSharedRefineMenuTypeahead_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [
        {
            "kind": "LocalArgument",
            "name": "searchString",
            "type": "String",
            "defaultValue": null
        },
        {
            "kind": "LocalArgument",
            "name": "facetName",
            "type": "String",
            "defaultValue": null
        },
        {
            "kind": "LocalArgument",
            "name": "hasQuery",
            "type": "Boolean",
            "defaultValue": false
        },
        {
            "kind": "RootArgument",
            "name": "uriRef",
            "type": "String"
        }
    ],
    "selections": [
        {
            "kind": "Condition",
            "passingValue": true,
            "condition": "hasQuery",
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "facetSearch",
                    "storageKey": null,
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "facetName",
                            "variableName": "facetName"
                        },
                        {
                            "kind": "Literal",
                            "name": "first",
                            "value": 5
                        },
                        {
                            "kind": "Literal",
                            "name": "page",
                            "value": 1
                        },
                        {
                            "kind": "Variable",
                            "name": "searchString",
                            "variableName": "searchString"
                        },
                        {
                            "kind": "Variable",
                            "name": "uriRef",
                            "variableName": "uriRef"
                        }
                    ],
                    "concreteType": "FacetsQueryConnection",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "SbSharedRefineMenuSearchResults_facetSearch",
                            "args": null
                        }
                    ]
                }
            ]
        }
    ]
} as any);
(node as any).hash = '4133a05b90cbaad2eea13ab86c2311a6';
export default node;
